const accordion = (() => {
  const accordionContainer = document.querySelectorAll('.accordion');
  const accordionCount = accordionContainer.length;
  const panel = document.querySelector('.panel');
  const panelAll = document.querySelectorAll('.panel');
  const panelAllCount = panelAll.length;
  let panelDefaultHeight = [];

  const offsetValue = 50;
  let defaultHeight = panel.offsetHeight;

  let clickStatus = false;
  // let clickTimeout;

  let userAgent = navigator.userAgent

  let type = {
    android: null,
    blackBerry: null,
    iOS: null,
    iOSMobile: null,
    iOSTablet: null,
    opera: null,
    windows: null,
    mobileOnly: null,
    all: null
  };

  type.android = /Android/i.test(userAgent)
  type.blackBerry = /BlackBerry/i.test(userAgent)
  type.iOS = /iPhone|iPad|iPod/i.test(userAgent)
  type.iOSMobile = /iPhone|iPod/i.test(userAgent)
  type.iOSTablet = /iPad/i.test(userAgent)
  type.opera = /Opera Mini/i.test(userAgent)
  type.windows = /IEMobile/i.test(userAgent)
  type.mobileOnly = type.android || type.blackBerry || type.iOSMobile || type.opera || type.windows
  type.all = type.android || type.blackBerry || type.iOS || type.opera || type.windows


  setTimeout(() => {
    initAccordion(defaultHeight, offsetValue);

    if (document.getElementById('themes__wrapper')) {
      const panel = document.querySelectorAll('.accordion .panel');
      const count = panel.length;

      for (let j = 0; j < count; j += 1) {
        panelDefaultHeight.push(panel[j].offsetHeight);
      }
    }
  }, 100);


  for (let i = 0; i < accordionCount; i += 1) {
    if (type.all) {
      accordionContainer[i].addEventListener('touchend', (event) => {
        if ((event.target && event.target.tagName === 'A') || (event.target && event.target.parentNode.parentNode.parentNode.getAttribute('data-parent') === '.accordion' && document.getElementById('themes__wrapper'))) {
          // clearTimeout(clickTimeout);

          // if (!clickStatus) {
          //   clickStatus = true;

          let panel = event.target.parentNode.parentNode;
          let id = event.target.getAttribute('data-id');
          let parentId = event.target.getAttribute('data-parent');

          if (document.getElementById('themes__wrapper')) {
            panel = event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
            id = event.target.parentNode.parentNode.parentNode.getAttribute('data-id');
            parentId = event.target.parentNode.parentNode.parentNode.getAttribute('data-parent');
          } else {
            panel = event.target.parentNode.parentNode;
            id = event.target.getAttribute('data-id');
            parentId = event.target.getAttribute('data-parent');
          }

          const accordionParent = document.querySelector(parentId);
          const accordionBody = document.querySelector(`${parentId} #collapse${id}`);
          const accordionHeight = accordionBody.offsetHeight;
          const allPanel = document.querySelectorAll(`${parentId} .panel`);

          if (!panel.classList.contains('open')) {
            if (document.getElementById('themes__wrapper')) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].style.height = `${panelDefaultHeight[j]}px`;
                allPanel[j].classList.remove('open');
                document.querySelectorAll('.accordion__icon')[j].classList.remove('is--minus');
              }
              document.querySelector(`.accordion__icon[data-id="${id}"]`).classList.add('is--minus');
            } else {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].classList.remove('open');
                allPanel[j].removeAttribute('style');
              }
            }

            panel.classList.add('open');

            if (document.getElementById('themes__wrapper')) {
              panel.style.height = `${accordionHeight + panelDefaultHeight[id]}px`;
            } else {
              panel.style.height = `${accordionHeight + defaultHeight}px`;
            }
          } else {
            if ((document.getElementById('home') && window.innerWidth < 992) || (!document.getElementById('home') && !document.getElementById('themes__wrapper'))) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].classList.remove('open');
                allPanel[j].removeAttribute('style');
              }
            } else if (document.getElementById('themes__wrapper')) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].style.height = `${panelDefaultHeight[j]}px`;
                allPanel[j].classList.remove('open');
              }
              document.querySelector(`.accordion__icon[data-id="${id}"]`).classList.remove('is--minus');
            }
          }
          // }

          // clickTimeout = setTimeout(() => {
          //   clickStatus = false;
          // }, 600);
        }
      });
    } else {
      accordionContainer[i].addEventListener('click', (event) => {
        if ((event.target && event.target.tagName === 'A') || (event.target && event.target.parentNode.parentNode.parentNode.getAttribute('data-parent') === '.accordion' && document.getElementById('themes__wrapper'))) {
          // clearTimeout(clickTimeout);

          // if (!clickStatus) {
          //   clickStatus = true;

          let panel = event.target.parentNode.parentNode;
          let id = event.target.getAttribute('data-id');
          let parentId = event.target.getAttribute('data-parent');

          if (document.getElementById('themes__wrapper')) {
            panel = event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
            id = event.target.parentNode.parentNode.parentNode.getAttribute('data-id');
            parentId = event.target.parentNode.parentNode.parentNode.getAttribute('data-parent');
          } else {
            panel = event.target.parentNode.parentNode;
            id = event.target.getAttribute('data-id');
            parentId = event.target.getAttribute('data-parent');
          }

          const accordionParent = document.querySelector(parentId);
          const accordionBody = document.querySelector(`${parentId} #collapse${id}`);
          const accordionHeight = accordionBody.offsetHeight;
          const allPanel = document.querySelectorAll(`${parentId} .panel`);

          if (!panel.classList.contains('open')) {
            if (document.getElementById('themes__wrapper')) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].style.height = `${panelDefaultHeight[j]}px`;
                allPanel[j].classList.remove('open');
                document.querySelectorAll('.accordion__icon')[j].classList.remove('is--minus');
              }
              document.querySelector(`.accordion__icon[data-id="${id}"]`).classList.add('is--minus');
            } else {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].classList.remove('open');
                allPanel[j].removeAttribute('style');
              }
            }

            panel.classList.add('open');

            if (document.getElementById('themes__wrapper')) {
              panel.style.height = `${accordionHeight + panelDefaultHeight[id]}px`;
            } else {
              panel.style.height = `${accordionHeight + defaultHeight}px`;
            }
          } else {
            if ((document.getElementById('home') && window.innerWidth < 992) || (!document.getElementById('home') && !document.getElementById('themes__wrapper'))) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].classList.remove('open');
                allPanel[j].removeAttribute('style');
              }
            } else if (document.getElementById('themes__wrapper')) {
              for (let j = 0; j < allPanel.length; j += 1) {
                allPanel[j].style.height = `${panelDefaultHeight[j]}px`;
                allPanel[j].classList.remove('open');
              }
              document.querySelector(`.accordion__icon[data-id="${id}"]`).classList.remove('is--minus');
            }
          }
          // }

          // clickTimeout = setTimeout(() => {
          //   clickStatus = false;
          // }, 600);
        }
      });
    }
  }

  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      setTimeout(() => {
        panelDefaultHeight = [];

        for (let i = 0; i < panelAllCount; i += 1) {
          if (!panelAll[i].classList.contains('open') && !document.getElementById('themes__wrapper')) {
            defaultHeight = panelAll[i].offsetHeight;
          } else if (document.getElementById('themes__wrapper')) {
            panelAll[i].removeAttribute('style');
            panelAll[i].classList.remove('open');
            document.querySelectorAll('.accordion__icon')[i].classList.remove('is--minus');
            defaultHeight = panelAll[i].offsetHeight;
            panelDefaultHeight.push(panelAll[i].offsetHeight);
          }
        }
        initAccordion(defaultHeight, offsetValue, true);
      }, 500);
    }, 300);
  });
})();

function initAccordion (defaultHeight, offsetValue, isResize) {
  if (document.getElementById('home') && window.innerWidth >= 992 && !document.querySelector('.panel.open')) {
    const panel = document.querySelectorAll('.panel');

    panel[0].classList.add('open');
    panel[0].style.height = `${panel[0].children[1].offsetHeight + defaultHeight + offsetValue}px`;
  }

  if (document.querySelector('.panel.open')) {
    const panelOpen = document.querySelectorAll('.panel.open');
    const count = panelOpen.length;

    for (let j = 0; j < count; j += 1) {
      panelOpen[j].style.height = `${panelOpen[j].children[1].offsetHeight + defaultHeight + offsetValue}px`;
    }
  }

  if (document.getElementById('themes__wrapper')) {
    const panel = document.querySelectorAll('.accordion .panel');
    const count = panel.length;

    for (let j = 0; j < count; j += 1) {
      panel[j].style.height = `${panel[j].offsetHeight}px`;
    }
  }
}

export default accordion;
